<template>
    <div v-if="totalPages > 1">
        <ul class="uk-pagination uk-flex-center uk-flex-right@m" uk-margin>
            <template v-if="windowStart > 1 && !notEnoughPages">
                <li :class="{'uk-active': isOnFirstPage}">
                    <a @click="loadPage(1)"><span>1</span></a>
                </li>
                <li :class="{'uk-active': isOnFirstPage}">
                    <a @click="loadPage('prev')"><span uk-pagination-previous></span></a>
                </li>
            </template>
            <template v-if="notEnoughPages">
                <template v-for="n in totalPages">
                    <li :class="{'uk-active': isCurrentPage(n)}">
                        <a @click="loadPage(n)"><span v-html="n"></span></a>
                    </li>
                </template>
            </template>
            <template v-else>
                <template v-for="n in windowSize">
                    <li :class="{'uk-active': isCurrentPage(windowStart + n - 1)}">
                        <a @click="loadPage(windowStart + n - 1)">
                            <span v-html="windowStart + n - 1"></span>
                        </a>
                    </li>
                </template>
            </template>
            <template v-if="(windowSize + windowStart <= totalPages) && !notEnoughPages">
                <li :class="{'uk-active': isOnLastPage}">
                    <a @click="loadPage('next')"><span uk-pagination-next></span></a>
                </li>
                <li :class="{'uk-active': isOnLastPage}">
                    <a @click="loadPage(totalPages)">{{ totalPages }}</a>
                </li>
            </template>
        </ul>
    </div>
</template>


<script>
    export default {
        props: {
            firstPage: {
                type: Number,
                default() {
                    return 1;
                }
            },
            lastPage: {
                type: Number,
                required: true,
                default() {
                    return 1
                }
            },
            currentPage: {
                type: Number,
                required: true,
                default() {
                    return 1
                }
            },
            totalPages: {
                type: Number,
                required: true,
                default() {
                    return 0;
                }
            },
            previousPage: {
                type: Number,
                required: true,
                default() {
                    return 1
                }
            },
            nextPage: {
                type: Number,
                required: true,
                default() {
                    return 1
                }
            },
            onEachSide: {
                type: Number,
                default() {
                    return 2
                }
            },
        },
        computed: {
            isOnFirstPage() {
                return this.currentPage === 1
            },
            isOnLastPage() {
                return this.currentPage === this.lastPage
            },
            notEnoughPages() {
                return this.totalPages < (this.onEachSide * 2) + 4
            },
            windowSize() {
                return this.onEachSide * 2 + 1;
            },
            windowStart() {
                if (this.currentPage <= this.onEachSide) {
                    return 1
                } else if (this.currentPage >= (this.totalPages - this.onEachSide)) {
                    return this.totalPages - this.onEachSide * 2
                }
                return this.currentPage - this.onEachSide
            },
        },
        methods: {
            loadPage(page) {
                this.$emit('load-page', page);
            },
            isCurrentPage(page) {
                return page === this.currentPage
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ShopItemsPagination.vue?24de8809